// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"532":"f687eb3a","632":"679b3c22"}[chunkId] + ".js";
};